import { MouseEvent, useCallback } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

export interface CopyPasteActionsProps {
  entityLabel: string;
  stopPropagation?: boolean;
  onCopy?: () => Promise<void> | void;
  onPasteAfter?: () => Promise<void> | void;
}

export const CopyPasteActions = ({
  onCopy,
  entityLabel,
  onPasteAfter,
  stopPropagation = false,
}: CopyPasteActionsProps) => {
  const handleClick = useCallback(
    async (
      event: MouseEvent<HTMLButtonElement>,
      callback?: () => Promise<void> | void
    ) => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      await callback?.();
    },
    [stopPropagation]
  );

  return (
    <>
      <Tooltip title={`Copy ${entityLabel}`}>
        <span>
          <IconButton
            size="small"
            disabled={!onCopy}
            aria-label={`Copy ${entityLabel}`}
            onClick={onCopy ? (event) => handleClick(event, onCopy) : undefined}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={`Paste ${entityLabel} after`}>
        <span>
          <IconButton
            size="small"
            disabled={!onPasteAfter}
            aria-label={`Paste ${entityLabel} after`}
            onClick={
              onPasteAfter
                ? (event) => handleClick(event, onPasteAfter)
                : undefined
            }
          >
            <ContentPasteIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
